var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{},[_c('ul',{staticClass:"divide-y"},_vm._l((_vm.notes),function(note,index){return _c('a',{key:index,staticClass:"flex flex-col p-4 md:flex-row hover:bg-default-200",attrs:{"href":note.links.url}},[_c('h6',{staticClass:"font-semibold"},[_vm._v(_vm._s(note.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }